module.exports = __webpack_public_path__ + "img/ico-google.9827cd27.svg";